export const formatCurrency = (amount: number) => {
  const digits = new Intl.NumberFormat('ja-JP', { maximumFractionDigits: 0 }).format(
    Math.abs(amount)
  )
  return `${amount < 0 ? '-' : ''}¥${digits}`
}
